module.exports = __webpack_public_path__ + "static/polarpumpen-min-0300db283c000afed5e791f77d1d0337.png";